import { keepPreviousData, queryOptions } from '@tanstack/react-query'

import { fetchAllPages } from '@/utils/api/fetchAllPages'

import type { UsersListParams } from '../types/users.types'
import { usersApi } from './usersApi'

const USERS_PAGE_SIZE = 200

export const usersQueries = {
  all: () => ['users'] as const,
  lists: () => [...usersQueries.all(), 'list'] as const,
  list: (params: UsersListParams) =>
    queryOptions({
      queryKey: [...usersQueries.lists(), params],
      queryFn: ({ signal }) =>
        fetchAllPages((page) =>
          usersApi.getUsers(
            { ...params, page, pageSize: USERS_PAGE_SIZE },
            { signal }
          )
        ),
      placeholderData: keepPreviousData,
    }),
}
